import { PropsOf } from 'types';
import connect from './connect';
import TextOverlayModalContents from './TextOverlayModalContents';

export default connect(TextOverlayModalContents);
export type TextOverlayModalContentsProps = PropsOf<ReturnType<typeof connect>>;
